
import { EEventType } from "src/app/domain/enums/eventType";
import { ESubContractingLab } from "src/app/domain/enums/sub-contracting-lab";

export class StringConverter {

    static getEventTypeName(freq: EEventType) {
        switch (freq) {
            case EEventType.Formation:
                return 'Formation';
            case EEventType.Intervention:
                return 'Intervention';
            case EEventType.Pause:
                return 'Pause';
            default:
                return 'Not Set';
        }
    }

    static getLabCodeName(lab: ESubContractingLab) {
        switch (lab) {
            case ESubContractingLab.EUFR17:
                return 'EUFR17';
            case ESubContractingLab.EUFRBO7:
                return 'EUFRBO7';
            case ESubContractingLab.EUFRCB:
                return 'EUFRCB';
            case ESubContractingLab.EUFRHB2:
                return 'EUFRHB2';
            case ESubContractingLab.EUFRNA8:
                return 'EUFRNA8';
            case ESubContractingLab.EUFRSG2:
                return 'EUFRSG2';
            case ESubContractingLab.EUFRVE5:
                return 'EUFRVE5';
            case ESubContractingLab.EULESA:
                return 'EULESA';
            case ESubContractingLab.EULHCF:
                return 'EULHCF';
            case ESubContractingLab.Externe:
                return 'Externe';
            case ESubContractingLab.EUFR266:
                return 'EUFR266';
            case ESubContractingLab.EUFR267:
                return 'EUFR267';
            default:
                return 'Not Set';
        }
    }
}
